export enum SrModelVersionEnum {
  Legacy = 1,
  V2 = 2,
}
